import type { FunctionComponent } from 'react';

import { ExpandableContent } from '@kanda-libs/ks-design-library';
import { UserType } from '@kanda-libs/ks-frontend-services';

import UserCard from './UserCard';
import UserModal from './UserModal';
import useUsers from './useUsers';

export interface CompanyUsersProps {
  users?: UserType[];
}

const CompanyUsers: FunctionComponent<CompanyUsersProps> = function ({
  users,
}) {
  const { onClick, user } = useUsers();
  if (!users) return <p>No users in company</p>;
  return (
    <ExpandableContent
      showLabel="Show company users"
      hideLabel="Hide company users"
    >
      <div className="grid grid-cols-2 gap-4">
        {users.map((user: UserType) => (
          <UserCard user={user} key={user.email} onClick={onClick} />
        ))}
      </div>
      <UserModal user={user} />
    </ExpandableContent>
  );
};

export default CompanyUsers;
